module.exports = __webpack_public_path__ + "img/menubuilder2.5173a34a.svg";